// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1yHOp","delete":"styles_delete__3Y55A","update":"styles_update__J6fJu","add":"styles_add__KSi63"};